// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   Alert,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemAvatar,
//   Avatar,
//   CircularProgress,
// } from '@mui/material';
// import { LocalTaxi, DirectionsCar, LocationOn } from '@mui/icons-material';
// import apiService from '../services/apiService';
// import socketService from '../services/socketService';

// const LiveTrackingPage = () => {
//   const [activeRides, setActiveRides] = useState([]);
//   const [onlineDrivers, setOnlineDrivers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');

//   const fetchLiveData = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError('');
//       const response = await apiService.getLiveTracking();

//       if (response.success) {
//         setActiveRides(response.data.activeRides || []);
//         setOnlineDrivers(response.data.onlineDrivers || []);
//       } else {
//         setError(response.message || 'Failed to load live data');
//         setActiveRides([]);
//         setOnlineDrivers([]);
//       }
//     } catch (err) {
//       console.error('Live tracking error:', err);
//       setError('Failed to load live data');
//       setActiveRides([]);
//       setOnlineDrivers([]);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchLiveData();

//     // Setup socket listeners
//     socketService.onLocationUpdate((data) => {
//       console.log('Location update:', data);
//     });

//     socketService.onRideUpdate(() => {
//       fetchLiveData();
//     });

//     // Join live tracking room
//     socketService.joinLiveTracking();

//     return () => {
//       socketService.leaveLiveTracking();
//     };
//   }, [fetchLiveData]);

//   const getStatusColor = (status) => {
//     const colors = {
//       searching_driver: 'warning',
//       driver_assigned: 'info',
//       driver_arrived: 'info',
//       in_progress: 'success',
//     };
//     return colors[status] || 'default';
//   };

//   return (
//     <Box>
//       <Box sx={{ mb: 3 }}>
//         <Typography variant="h4" fontWeight="bold" gutterBottom>
//           Live Tracking
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           Real-time tracking of active rides and online drivers
//         </Typography>
//       </Box>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           {error}
//         </Alert>
//       )}

//       {loading && (
//         <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
//           <CircularProgress size={24} />
//         </Box>
//       )}

//       <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
//         <Card sx={{ flex: 1 }}>
//           <CardContent>
//             <Typography variant="h3" fontWeight="bold" color="success.main">
//               {activeRides.length}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Active Rides
//             </Typography>
//           </CardContent>
//         </Card>
//         <Card sx={{ flex: 1 }}>
//           <CardContent>
//             <Typography variant="h3" fontWeight="bold" color="primary.main">
//               {onlineDrivers.length}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Online Drivers
//             </Typography>
//           </CardContent>
//         </Card>
//       </Box>

//       <Box sx={{ display: 'flex', gap: 3 }}>
//         {/* Active Rides */}
//         <Card sx={{ flex: 1 }}>
//           <CardContent>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
//               <LocalTaxi color="primary" />
//               <Typography variant="h6" fontWeight={600}>
//                 Active Rides
//               </Typography>
//             </Box>
//             {activeRides.length === 0 ? (
//               <Box sx={{ textAlign: 'center', py: 4 }}>
//                 <LocalTaxi sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
//                 <Typography variant="body2" color="text.secondary">
//                   No active rides at the moment
//                 </Typography>
//               </Box>
//             ) : (
//               <List>
//                 {activeRides.map((ride) => (
//                   <ListItem key={ride.id} divider>
//                     <ListItemAvatar>
//                       <Avatar sx={{ bgcolor: 'primary.main' }}>
//                         <LocalTaxi />
//                       </Avatar>
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <Typography variant="body2" fontWeight={600}>
//                             {ride.id?.substring(0, 12)}...
//                           </Typography>
//                           <Chip label={ride.status?.replace('_', ' ')} color={getStatusColor(ride.status)} size="small" />
//                         </Box>
//                       }
//                       secondary={
//                         <Box>
//                           <Typography variant="caption" display="block">
//                             Passenger: {ride.passenger || '-'}
//                           </Typography>
//                           <Typography variant="caption" display="block">
//                             Driver: {ride.driver || 'Not assigned'} {ride.vehicleType ? `(${ride.vehicleType})` : ''}
//                           </Typography>
//                           <Typography variant="caption" display="block">
//                             {ride.pickupLocation || 'N/A'} → {ride.dropLocation || 'N/A'}
//                           </Typography>
//                         </Box>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             )}
//           </CardContent>
//         </Card>

//         {/* Online Drivers */}
//         <Card sx={{ flex: 1 }}>
//           <CardContent>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
//               <DirectionsCar color="success" />
//               <Typography variant="h6" fontWeight={600}>
//                 Online Drivers
//               </Typography>
//             </Box>
//             {onlineDrivers.length === 0 ? (
//               <Box sx={{ textAlign: 'center', py: 4 }}>
//                 <DirectionsCar sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
//                 <Typography variant="body2" color="text.secondary">
//                   No drivers online at the moment
//                 </Typography>
//               </Box>
//             ) : (
//               <List>
//                 {onlineDrivers.map((driver) => (
//                   <ListItem key={driver.id} divider>
//                     <ListItemAvatar>
//                       <Avatar sx={{ bgcolor: 'success.main' }}>
//                         <DirectionsCar />
//                       </Avatar>
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={driver.name || 'Unknown Driver'}
//                       secondary={
//                         <Box>
//                           <Typography variant="caption" display="block">
//                             {driver.vehicleType || 'N/A'} {driver.vehicleNumber ? `- ${driver.vehicleNumber}` : ''}
//                           </Typography>
//                           <Typography variant="caption" display="flex" alignItems="center" gap={0.5}>
//                             <LocationOn sx={{ fontSize: 14 }} />
//                             {driver.currentLocation || 'Location unavailable'}
//                           </Typography>
//                         </Box>
//                       }
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             )}
//           </CardContent>
//         </Card>
//       </Box>

//       <Alert severity="info" sx={{ mt: 3 }}>
//         <strong>Note:</strong> This page shows real-time data. The map integration with Google Maps will be added in future updates.
//       </Alert>
//     </Box>
//   );
// };

// export default LiveTrackingPage;

import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Alert,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  CircularProgress,
  Paper,
  IconButton,
  Tooltip,
  TextField,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  Badge,
  Tabs,
  Tab,
  Divider,
} from '@mui/material';
import { 
  LocalTaxi, 
  DirectionsCar, 
  LocationOn,
  ZoomIn,
  ZoomOut,
  Refresh,
  Person,
  Place,
  Star,
  Search,
  Clear,
  Phone,
  DirectionsCar as CarIcon,
  Person as PersonIcon,
  PowerSettingsNew,
  Circle,
} from '@mui/icons-material';
import apiService from '../services/apiService';
import socketService from '../services/socketService';

const LiveTrackingPage = () => {
  const [activeRides, setActiveRides] = useState([]);
  const [onlineDrivers, setOnlineDrivers] = useState([]);
  const [offlineDrivers, setOfflineDrivers] = useState([]);
  const [filteredOnlineDrivers, setFilteredOnlineDrivers] = useState([]);
  const [filteredOfflineDrivers, setFilteredOfflineDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [userLocation, setUserLocation] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchField, setSearchField] = useState('all');
  const [activeTab, setActiveTab] = useState(0);
  
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markersRef = useRef({});
  const infoWindowsRef = useRef({});
  const defaultCenter = { lat: 40.7128, lng: -74.0060 };

  // Initialize Google Maps
  const initMap = useCallback(() => {
    if (!window.google || !mapRef.current) return;

    const center = userLocation || defaultCenter;
    
    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: center,
      zoom: 12,
      styles: [
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }]
        }
      ],
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
    });

    // Add current location button
    const locationButton = document.createElement('button');
    locationButton.innerHTML = '<span style="font-size:20px">📍</span>';
    locationButton.style.cssText = `
      position: absolute;
      bottom: 20px;
      right: 20px;
      z-index: 10;
      background: white;
      border: none;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
    `;
    locationButton.onmouseover = () => {
      locationButton.style.transform = 'scale(1.1)';
    };
    locationButton.onmouseout = () => {
      locationButton.style.transform = 'scale(1)';
    };
    locationButton.title = 'Go to my location';
    locationButton.onclick = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            setUserLocation(pos);
            if (mapInstance.current) {
              mapInstance.current.panTo(pos);
              mapInstance.current.setZoom(14);
            }
          },
          () => {
            console.error('Error getting location');
          }
        );
      }
    };
    mapRef.current.appendChild(locationButton);

    setMapLoaded(true);
  }, [userLocation]);

  // Search/filter drivers
  const filterDrivers = useCallback((drivers, query, field) => {
    if (!drivers || drivers.length === 0) return [];
    if (!query.trim()) {
      return drivers;
    }

    const searchTerm = query.toLowerCase().trim();
    
    return drivers.filter(driver => {
      switch (field) {
        case 'name':
          return driver.name?.toLowerCase().includes(searchTerm);
        case 'phone':
          return driver.phone?.toLowerCase().includes(searchTerm);
        case 'vehicle':
          return driver.vehicleNumber?.toLowerCase().includes(searchTerm) || 
                 driver.vehicleType?.toLowerCase().includes(searchTerm);
        case 'all':
        default:
          return (
            driver.name?.toLowerCase().includes(searchTerm) ||
            driver.phone?.toLowerCase().includes(searchTerm) ||
            driver.vehicleNumber?.toLowerCase().includes(searchTerm) ||
            driver.vehicleType?.toLowerCase().includes(searchTerm)
          );
      }
    });
  }, []);

  // Update filtered drivers when search changes
  useEffect(() => {
    const filteredOnline = filterDrivers(onlineDrivers, searchQuery, searchField);
    const filteredOffline = filterDrivers(offlineDrivers, searchQuery, searchField);
    setFilteredOnlineDrivers(filteredOnline);
    setFilteredOfflineDrivers(filteredOffline);
  }, [onlineDrivers, offlineDrivers, searchQuery, searchField, filterDrivers]);

  // Get driver position helper function
  const getDriverPosition = useCallback((driver) => {
    if (!driver) return null;
    
    if (driver.latitude && driver.longitude) {
      return {
        lat: parseFloat(driver.latitude),
        lng: parseFloat(driver.longitude),
      };
    }
    
    if (driver.currentLocation) {
      if (typeof driver.currentLocation === 'object') {
        const lat = driver.currentLocation.lat || driver.currentLocation.latitude;
        const lng = driver.currentLocation.lng || driver.currentLocation.longitude;
        if (lat && lng) {
          return {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
          };
        }
      }
    }
    
    if (driver.location) {
      if (typeof driver.location === 'object') {
        const lat = driver.location.lat || driver.location.latitude;
        const lng = driver.location.lng || driver.location.longitude;
        if (lat && lng) {
          return {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
          };
        }
      }
    }
    
    const possibleLatFields = ['lat', 'latitude', 'Latitude', 'LAT'];
    const possibleLngFields = ['lng', 'longitude', 'Longitude', 'LNG', 'lon'];
    
    for (const field of possibleLatFields) {
      if (driver[field]) {
        const lat = parseFloat(driver[field]);
        if (!isNaN(lat)) {
          for (const lngField of possibleLngFields) {
            if (driver[lngField]) {
              const lng = parseFloat(driver[lngField]);
              if (!isNaN(lng)) {
                return { lat, lng };
              }
            }
          }
        }
      }
    }
    
    return null;
  }, []);

  // Update markers when drivers change
  const updateMarkers = useCallback(() => {
    if (!mapInstance.current || !window.google) return;

    // Clear existing markers
    Object.values(markersRef.current).forEach(marker => marker.setMap(null));
    Object.values(infoWindowsRef.current).forEach(infoWindow => infoWindow.close());
    markersRef.current = {};
    infoWindowsRef.current = {};

    // Combine online and offline drivers based on active tab
    let driversToShow = [];
    if (activeTab === 0) {
      // Show all drivers (online + offline with positions)
      driversToShow = [...onlineDrivers, ...offlineDrivers];
    } else if (activeTab === 1) {
      // Show only online drivers
      driversToShow = filteredOnlineDrivers;
    } else if (activeTab === 2) {
      // Show only offline drivers
      driversToShow = filteredOfflineDrivers;
    }
    
    const driversWithPositions = driversToShow.filter(driver => {
      const pos = getDriverPosition(driver);
      return pos && !isNaN(pos.lat) && !isNaN(pos.lng);
    });

    if (driversWithPositions.length === 0) {
      const center = userLocation || defaultCenter;
      if (mapInstance.current) {
        mapInstance.current.panTo(center);
        mapInstance.current.setZoom(12);
      }
      return;
    }

    driversWithPositions.forEach((driver) => {
      const position = getDriverPosition(driver);
      if (!position) return;

      // Check if driver is online or offline
      const isOnline = driver.status === 'online' || driver.isOnline === true || onlineDrivers.some(d => d.id === driver.id);
      
      const marker = new window.google.maps.Marker({
        position: position,
        map: mapInstance.current,
        title: driver.name || 'Driver',
        icon: {
          url: isOnline 
            ? 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
            : 'https://maps.google.com/mapfiles/ms/icons/grey-dot.png',
          scaledSize: new window.google.maps.Size(32, 32),
          labelOrigin: new window.google.maps.Point(16, 45),
        },
        label: {
          text: isOnline ? '🚗' : '🚙',
          color: '#000',
          fontSize: '16px',
          fontWeight: 'bold',
        },
        animation: isOnline ? window.google.maps.Animation.DROP : null,
      });

      const locationString = getDriverLocationString(driver);

      const infoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="padding: 12px; max-width: 280px; font-family: Arial, sans-serif;">
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;">
              <div style="font-weight: 600; font-size: 16px; color: #1a1a1a;">
                ${driver.name || 'Unknown Driver'}
              </div>
              <span style="background: ${isOnline ? '#4CAF50' : '#9E9E9E'}; color: white; padding: 2px 10px; border-radius: 12px; font-size: 10px; font-weight: 600;">
                ${isOnline ? 'ONLINE' : 'OFFLINE'}
              </span>
            </div>
            <div style="font-size: 13px; color: #666; margin-bottom: 6px;">
              🚗 ${driver.vehicleType || 'N/A'} - ${driver.vehicleNumber || 'N/A'}
            </div>
            <div style="font-size: 13px; color: #666; margin-bottom: 6px; display: flex; align-items: flex-start; gap: 4px;">
              <span>📍</span>
              <span style="word-break: break-all;">${locationString}</span>
            </div>
            ${driver.phone ? `<div style="font-size: 13px; color: #666; margin-bottom: 4px;">📱 ${driver.phone}</div>` : ''}
            ${driver.rating ? `<div style="font-size: 13px; color: #f59e0b; margin-bottom: 4px;">⭐ ${driver.rating}/5 (${driver.totalTrips || 0} trips)</div>` : ''}
            <div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #e5e7eb; font-size: 11px; color: #666;">
              ● Last updated: ${new Date().toLocaleTimeString()}
            </div>
          </div>
        `,
      });

      marker.addListener('click', () => {
        Object.values(infoWindowsRef.current).forEach(iw => iw.close());
        infoWindow.open(mapInstance.current, marker);
        setSelectedDriver(driver);
      });

      markersRef.current[driver.id] = marker;
      infoWindowsRef.current[driver.id] = infoWindow;
    });

    const bounds = new window.google.maps.LatLngBounds();
    let hasBounds = false;
    
    driversWithPositions.forEach((driver) => {
      const pos = getDriverPosition(driver);
      if (pos) {
        bounds.extend(pos);
        hasBounds = true;
      }
    });
    
    if (userLocation) {
      bounds.extend(userLocation);
      hasBounds = true;
    }
    
    if (hasBounds && mapInstance.current) {
      mapInstance.current.fitBounds(bounds);
      
      const listener = window.google.maps.event.addListener(mapInstance.current, 'idle', () => {
        const zoom = mapInstance.current.getZoom();
        if (zoom > 15) {
          mapInstance.current.setZoom(15);
        } else if (zoom < 10) {
          mapInstance.current.setZoom(10);
        }
        window.google.maps.event.removeListener(listener);
      });
    }

  }, [onlineDrivers, offlineDrivers, filteredOnlineDrivers, filteredOfflineDrivers, 
      activeTab, userLocation, getDriverPosition]);

  // Get driver location string
  const getDriverLocationString = (driver) => {
    if (!driver) return 'Location unavailable';
    
    if (typeof driver.currentLocation === 'string') {
      return driver.currentLocation;
    }
    
    if (driver.currentLocation && typeof driver.currentLocation === 'object') {
      if (driver.currentLocation.address) {
        return driver.currentLocation.address;
      }
      if (driver.currentLocation.lat && driver.currentLocation.lng) {
        return `${driver.currentLocation.lat.toFixed(6)}, ${driver.currentLocation.lng.toFixed(6)}`;
      }
    }
    
    if (driver.latitude && driver.longitude) {
      return `${parseFloat(driver.latitude).toFixed(6)}, ${parseFloat(driver.longitude).toFixed(6)}`;
    }
    
    return 'Location unavailable';
  };

  // Get user location on mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setUserLocation(pos);
        },
        (error) => {
          console.log('Geolocation error:', error);
          setUserLocation(defaultCenter);
        }
      );
    } else {
      setUserLocation(defaultCenter);
    }
  }, []);

  // Load Google Maps script
  useEffect(() => {
    if (!window.google) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = initMap;
      document.head.appendChild(script);
      
      return () => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };
    } else {
      initMap();
    }

    return () => {
      Object.values(markersRef.current).forEach(marker => marker.setMap(null));
      markersRef.current = {};
      Object.values(infoWindowsRef.current).forEach(infoWindow => infoWindow.close());
      infoWindowsRef.current = {};
    };
  }, [initMap]);

  // Update markers when map loads or drivers change
  useEffect(() => {
    if (mapLoaded) {
      updateMarkers();
    }
  }, [updateMarkers, mapLoaded]);

  // Fetch live data
  const fetchLiveData = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await apiService.getLiveTracking();

      console.log('API Response:', response); // Debug log

      if (response.success) {
        setActiveRides(response.data.activeRides || []);
        
        // Handle different API response structures
        let allDrivers = [];
        
        // Try different possible data structures
        if (response.data.drivers) {
          allDrivers = response.data.drivers;
        } else if (response.data.onlineDrivers) {
          // If API returns separate online and offline arrays
          const online = response.data.onlineDrivers || [];
          const offline = response.data.offlineDrivers || [];
          allDrivers = [...online, ...offline];
        } else if (Array.isArray(response.data)) {
          // If response.data is directly an array
          allDrivers = response.data;
        } else if (response.data.driverList) {
          allDrivers = response.data.driverList;
        } else {
          // Try to find any array in the response
          const dataKeys = Object.keys(response.data);
          for (const key of dataKeys) {
            if (Array.isArray(response.data[key]) && response.data[key].length > 0) {
              // Check if it looks like driver data
              const firstItem = response.data[key][0];
              if (firstItem && (firstItem.name || firstItem.phone || firstItem.vehicleNumber)) {
                allDrivers = response.data[key];
                break;
              }
            }
          }
        }

        console.log('All Drivers:', allDrivers); // Debug log

        // Separate online and offline drivers
        const online = allDrivers.filter(d => 
          d.status === 'online' || 
          d.isOnline === true || 
          d.is_online === true ||
          d.online === true
        );
        
        const offline = allDrivers.filter(d => 
          d.status === 'offline' || 
          d.isOnline === false || 
          d.is_online === false ||
          d.online === false ||
          (!d.status && !d.isOnline && !d.is_online && !d.online) // Assume offline if no status
        );

        console.log('Online Drivers:', online);
        console.log('Offline Drivers:', offline);

        setOnlineDrivers(online);
        setOfflineDrivers(offline);
      } else {
        setError(response.message || 'Failed to load live data');
        setActiveRides([]);
        setOnlineDrivers([]);
        setOfflineDrivers([]);
      }
    } catch (err) {
      console.error('Live tracking error:', err);
      setError('Failed to load live data: ' + err.message);
      setActiveRides([]);
      setOnlineDrivers([]);
      setOfflineDrivers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Setup socket listeners
  useEffect(() => {
    fetchLiveData();

    socketService.onLocationUpdate((data) => {
      console.log('Location update:', data);
      setOnlineDrivers(prevDrivers => 
        prevDrivers.map(driver => 
          driver.id === data.driverId 
            ? { 
                ...driver, 
                latitude: data.latitude, 
                longitude: data.longitude,
                currentLocation: data.address || data.currentLocation || `${data.latitude}, ${data.longitude}`
              }
            : driver
        )
      );
    });

    socketService.onRideUpdate(() => {
      fetchLiveData();
    });

    socketService.joinLiveTracking();

    return () => {
      socketService.leaveLiveTracking();
    };
  }, [fetchLiveData]);

  const getStatusColor = (status) => {
    const colors = {
      searching_driver: 'warning',
      driver_assigned: 'info',
      driver_arrived: 'info',
      in_progress: 'success',
    };
    return colors[status] || 'default';
  };

  const handleZoomIn = () => {
    if (mapInstance.current) {
      const zoom = mapInstance.current.getZoom();
      mapInstance.current.setZoom(zoom + 1);
    }
  };

  const handleZoomOut = () => {
    if (mapInstance.current) {
      const zoom = mapInstance.current.getZoom();
      mapInstance.current.setZoom(zoom - 1);
    }
  };

  const handleRefresh = () => {
    fetchLiveData();
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setSelectedDriver(null);
    Object.values(infoWindowsRef.current).forEach(iw => iw.close());
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setSelectedDriver(null);
    Object.values(infoWindowsRef.current).forEach(iw => iw.close());
  };

  // Handle driver selection from list
  const handleDriverSelect = (driver) => {
    setSelectedDriver(driver);
    
    if (!mapInstance.current) return;
    
    const position = getDriverPosition(driver);
    
    if (position && !isNaN(position.lat) && !isNaN(position.lng)) {
      mapInstance.current.panTo(position);
      mapInstance.current.setZoom(16);
      
      if (markersRef.current[driver.id]) {
        Object.values(infoWindowsRef.current).forEach(iw => iw.close());
        infoWindowsRef.current[driver.id].open(mapInstance.current, markersRef.current[driver.id]);
      }
    } else {
      setError('Driver location data is not available');
      setTimeout(() => setError(''), 3000);
    }
  };

  // Clear selected driver when clicking on map
  const handleMapClick = useCallback(() => {
    setSelectedDriver(null);
    Object.values(infoWindowsRef.current).forEach(iw => iw.close());
  }, []);

  // Add map click listener
  useEffect(() => {
    if (mapInstance.current) {
      mapInstance.current.addListener('click', handleMapClick);
    }
    return () => {
      if (mapInstance.current) {
        window.google?.maps?.event?.clearInstanceListeners?.(mapInstance.current);
      }
    };
  }, [handleMapClick]);

  // Highlight matching text in search results
  const highlightMatch = (text, query) => {
    if (!query.trim() || !text) return text;
    const parts = text.split(new RegExp(`(${query.trim()})`, 'gi'));
    return parts.map((part, index) => 
      part.toLowerCase() === query.trim().toLowerCase() 
        ? <span key={index} style={{ backgroundColor: '#ffeb3b', fontWeight: 'bold' }}>{part}</span>
        : part
    );
  };

  // Get current drivers based on active tab
  const getCurrentDrivers = () => {
    if (activeTab === 0) {
      // All drivers (online + offline)
      return [...onlineDrivers, ...offlineDrivers];
    } else if (activeTab === 1) {
      return filteredOnlineDrivers;
    } else {
      return filteredOfflineDrivers;
    }
  };

  const currentDrivers = getCurrentDrivers();

  return (
    <Box>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Live Tracking
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Real-time tracking of active rides, online and offline drivers
          </Typography>
        </Box>
        <Box>
          <Tooltip title="Refresh">
            <IconButton onClick={handleRefresh} color="primary">
              <Refresh />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <CircularProgress size={24} />
        </Box>
      )}

      {/* Stats Cards */}
      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <Typography variant="h3" fontWeight="bold" color="success.main">
              {activeRides.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Active Rides
            </Typography>
          </CardContent>
        </Card>
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <Typography variant="h3" fontWeight="bold" color="primary.main">
              {onlineDrivers.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <Circle sx={{ fontSize: 10, color: '#4CAF50', verticalAlign: 'middle', mr: 0.5 }} />
              Online Drivers
            </Typography>
          </CardContent>
        </Card>
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <Typography variant="h3" fontWeight="bold" color="text.secondary">
              {offlineDrivers.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <Circle sx={{ fontSize: 10, color: '#9E9E9E', verticalAlign: 'middle', mr: 0.5 }} />
              Offline Drivers
            </Typography>
          </CardContent>
        </Card>
      </Box>

      {/* Google Map */}
      <Card sx={{ mb: 3, position: 'relative' }}>
        <CardContent sx={{ p: 0 }}>
          <Box 
            ref={mapRef} 
            sx={{ 
              height: 500, 
              width: '100%',
              borderRadius: 1,
              position: 'relative',
              backgroundColor: '#e5e7eb',
            }}
          />
          {/* Map Controls */}
          <Box sx={{ position: 'absolute', bottom: 80, right: 20, zIndex: 10 }}>
            <Paper elevation={3} sx={{ display: 'flex', flexDirection: 'column', borderRadius: 1, overflow: 'hidden' }}>
              <IconButton onClick={handleZoomIn} size="small" sx={{ borderRadius: 0, borderBottom: '1px solid #e5e7eb' }}>
                <ZoomIn />
              </IconButton>
              <IconButton onClick={handleZoomOut} size="small" sx={{ borderRadius: 0 }}>
                <ZoomOut />
              </IconButton>
            </Paper>
          </Box>
          
          {/* Map Legend */}
          <Paper 
            elevation={2} 
            sx={{ 
              position: 'absolute', 
              bottom: 140, 
              left: 20, 
              zIndex: 10,
              p: 1,
              backgroundColor: 'rgba(255,255,255,0.95)',
              borderRadius: 1,
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Circle sx={{ fontSize: 12, color: '#4CAF50' }} />
                <Typography variant="caption">Online Driver</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Circle sx={{ fontSize: 12, color: '#9E9E9E' }} />
                <Typography variant="caption">Offline Driver</Typography>
              </Box>
            </Box>
          </Paper>
        </CardContent>
      </Card>

      {/* Tabs and Lists */}
      <Box sx={{ display: 'flex', gap: 3 }}>
        {/* Active Rides */}
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <LocalTaxi color="primary" />
              <Typography variant="h6" fontWeight={600}>
                Active Rides
              </Typography>
            </Box>
            {activeRides.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <LocalTaxi sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                <Typography variant="body2" color="text.secondary">
                  No active rides at the moment
                </Typography>
              </Box>
            ) : (
              <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                {activeRides.map((ride) => (
                  <ListItem key={ride.id} divider>
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: 'primary.main' }}>
                        <LocalTaxi />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="body2" fontWeight={600}>
                            {ride.id?.substring(0, 12)}...
                          </Typography>
                          <Chip 
                            label={ride.status?.replace('_', ' ')} 
                            color={getStatusColor(ride.status)} 
                            size="small" 
                          />
                        </Box>
                      }
                      secondary={
                        <Box>
                          <Typography variant="caption" display="block">
                            <Person sx={{ fontSize: 12, mr: 0.5 }} />
                            Passenger: {ride.passenger || '-'}
                          </Typography>
                          <Typography variant="caption" display="block">
                            <DirectionsCar sx={{ fontSize: 12, mr: 0.5 }} />
                            Driver: {ride.driver || 'Not assigned'} {ride.vehicleType ? `(${ride.vehicleType})` : ''}
                          </Typography>
                          <Typography variant="caption" display="block">
                            <Place sx={{ fontSize: 12, mr: 0.5 }} />
                            {ride.pickupLocation || 'N/A'} → {ride.dropLocation || 'N/A'}
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </CardContent>
        </Card>

        {/* Drivers with Tabs and Search */}
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <DirectionsCar color="success" />
              <Typography variant="h6" fontWeight={600}>
                Drivers
              </Typography>
              <Chip 
                label={`${onlineDrivers.length} Online / ${offlineDrivers.length} Offline`} 
                size="small" 
                color="primary" 
              />
            </Box>

            {/* Tabs */}
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange}
              sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
            >
              <Tab label={`All (${onlineDrivers.length + offlineDrivers.length})`} />
              <Tab 
                label={`Online (${filteredOnlineDrivers.length})`} 
                icon={<Circle sx={{ fontSize: 12, color: '#4CAF50' }} />}
                iconPosition="start"
              />
              <Tab 
                label={`Offline (${filteredOfflineDrivers.length})`}
                icon={<Circle sx={{ fontSize: 12, color: '#9E9E9E' }} />}
                iconPosition="start"
              />
            </Tabs>

            {/* Search Bar */}
            <Paper 
              elevation={0} 
              sx={{ 
                p: 1, 
                mb: 2, 
                backgroundColor: '#f5f5f5',
                display: 'flex',
                gap: 1,
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              <TextField
                size="small"
                placeholder="Search drivers..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ flex: 1, minWidth: 150 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: searchQuery && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={handleClearSearch}>
                        <Clear fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              
              <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select
                  value={searchField}
                  onChange={(e) => setSearchField(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="all">All Fields</MenuItem>
                  <MenuItem value="name">Name</MenuItem>
                  <MenuItem value="phone">Phone</MenuItem>
                  <MenuItem value="vehicle">Vehicle</MenuItem>
                </Select>
              </FormControl>
            </Paper>

            {currentDrivers.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                {searchQuery ? (
                  <>
                    <Search sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body2" color="text.secondary">
                      No drivers found matching "{searchQuery}"
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Try adjusting your search terms
                    </Typography>
                  </>
                ) : (
                  <>
                    <DirectionsCar sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body2" color="text.secondary">
                      No drivers found
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {onlineDrivers.length === 0 && offlineDrivers.length === 0 
                        ? 'No driver data available from API' 
                        : 'Try refreshing or check your connection'}
                    </Typography>
                  </>
                )}
              </Box>
            ) : (
              <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                {currentDrivers.map((driver) => {
                  const isOnline = onlineDrivers.some(d => d.id === driver.id);
                  return (
                    <ListItem 
                      key={driver.id} 
                      divider
                      sx={{ 
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: 'action.hover' },
                        backgroundColor: selectedDriver?.id === driver.id ? 'action.selected' : 'transparent',
                      }}
                      onClick={() => handleDriverSelect(driver)}
                    >
                      <ListItemAvatar>
                        <Avatar sx={{ bgcolor: isOnline ? 'success.main' : 'grey.400' }}>
                          <DirectionsCar />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <Typography variant="body2" fontWeight={600}>
                              {searchQuery ? highlightMatch(driver.name || 'Unknown Driver', searchQuery) : (driver.name || 'Unknown Driver')}
                            </Typography>
                            <Chip 
                              label={isOnline ? 'ONLINE' : 'OFFLINE'} 
                              size="small" 
                              color={isOnline ? 'success' : 'default'}
                              variant="outlined"
                            />
                            {driver.rating && (
                              <Chip 
                                icon={<Star sx={{ fontSize: 14 }} />} 
                                label={`${driver.rating}⭐`} 
                                size="small" 
                                sx={{ backgroundColor: '#fef3c7', color: '#d97706' }}
                              />
                            )}
                          </Box>
                        }
                        secondary={
                          <Box>
                            <Typography variant="caption" display="block">
                              🚗 {driver.vehicleType || 'N/A'} - 
                              {searchQuery ? highlightMatch(driver.vehicleNumber || 'N/A', searchQuery) : (driver.vehicleNumber || 'N/A')}
                            </Typography>
                            {driver.phone && (
                              <Typography variant="caption" display="flex" alignItems="center" gap={0.5} sx={{ mt: 0.5 }}>
                                <Phone sx={{ fontSize: 12 }} />
                                {searchQuery ? highlightMatch(driver.phone, searchQuery) : driver.phone}
                              </Typography>
                            )}
                            <Typography variant="caption" display="flex" alignItems="center" gap={0.5} sx={{ mt: 0.5 }}>
                              <LocationOn sx={{ fontSize: 12 }} />
                              {getDriverLocationString(driver)}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                  );
                })}
              </List>
            )}
          </CardContent>
        </Card>
      </Box>

      <Alert severity="info" sx={{ mt: 3 }}>
        <strong>Live Tracking:</strong> Click on any driver marker or list item to focus on their location. 
        Use tabs to filter between all, online, or offline drivers. 
        Use the search bar to find drivers by name, phone number, or vehicle number.
        {currentDrivers.length > 0 && ` Found ${currentDrivers.length} driver${currentDrivers.length > 1 ? 's' : ''}.`}
        {onlineDrivers.length === 0 && offlineDrivers.length === 0 && ' No driver data available.'}
      </Alert>
    </Box>
  );
};

export default LiveTrackingPage;